<template>
  <v-container>
    <h2 class="mb-3">{{$t('overtime_category')}}</h2>
    <v-dialog v-model="addOvertimeDialog" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-row>
          <v-col>
            <v-btn right color="primary" dark class="mb-2" v-on="on" @click="addedItem()">{{$t('add_category')}}</v-btn>
          </v-col>
          <v-col md="6" class="pt-0">
            <v-text-field :rules="[validator.alfaNumberNotRequired]" :label="$t('find_a_category')" prepend-inner-icon="mdi-magnify" single-line
              v-model="search"></v-text-field>
          </v-col>
        </v-row>
      </template>
      <v-form v-model="valid" ref="addForm">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{$t('add_category')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field :label="$t('code_overtime')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="addItem.code"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field :label="$t('overtime_name_id')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="addItem.name_id">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field :label="$t('overtime_name_en')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="addItem.name_en"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select :items="appType" :label="$t('approval_type')" :rules="rules" v-model="addItem.approval_type"
                    item-text="name" item-value="id"></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn :loading="loading" color="primary" @click="addOvertime(addItem)" :disabled="!valid">{{$t('save')}}
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="editOvertimeDialog" max-width="500px">
      <v-card class="pt-3">
        <v-card-title>
          <span class="headline ml-2">{{$t('edit_category')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field :label="$t('code_overtime')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="editItem.code"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field :label="$t('overtime_name_id')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="editItem.name_id"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field :label="$t('overtime_name_en')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="editItem.name_en"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select :items="appType" :label="$t('approval_type')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="editItem.approval_type" item-text="name"
                  item-value="id"></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mx-6 pb-6">
          <v-row justify="center">
            <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
            <v-btn color="primary" :loading="loading" @click="editOvertime(editItem)">{{$t('save')}}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteOvertimeDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete_category')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteOvertimeDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" @click="deleteOvertime(itemToDelete.id)">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table :search="search" :items="overtime_list" :headers="headers" class="elevation-1 mt-3" :no-data-text="$t('no_data')"
      :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }">
      <template v-slot:item.approval_type="{ item }">
        <div v-if="item.approval_type == 1">{{$t('1_layer')}}</div>
        <div v-else>{{$t('2_layer')}}</div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" color="primary" @click="editedItem(item)">mdi-pencil</v-icon>
        <v-icon small color="error" @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:item.is_attachment="{ item }">
        <div v-if="item.is_attachment == true">{{$t('mandatory')}}</div>
        <div v-else>{{$t('not_mandatory')}}</div>
      </template>
      <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: "overtime",
  data() {
    return {
      headers: [
        { text: this.$i18n.t('code_overtime'), value: "code" },
        { text: this.$i18n.t('overtime_name_id'), value: "name_id" },
        { text: this.$i18n.t('overtime_name_en'), value: "name_en" },
        { text: this.$i18n.t('approval_type'), value: "approval_type" },
        { text: this.$i18n.t('manage'), value: "action" },
      ],
      appType: [{
          name: this.$i18n.t('1_layer'),
          id: 1,
        },
        {
          name: this.$i18n.t('2_layer'),
          id: 2,
        }
      ],
      company_id: this.$store.state.company,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      overtime_list: [],
      search: "",
      addItem: {
        code: "",
        name_id: "",
        name_en: "",
        companyId: "",
        approval_type: "",
      },
      editItem: {
        code: "",
        name_id: "",
        name_en: "",
        companyId: "",
        approval_type: "",
      },
      itemToDelete: {
        id: "",
        companyId: "",
      },
      overtime: [
        {
          id: "",
          companyId: "",
        },
      ],
      addOvertimeDialog: false,
      deleteOvertimeDialog: false,
      editOvertimeDialog: false,
      loading: false,
      editedIndex: -1,
      rules: [(v) => !!v || `${this.$i18n.t('required')}`],
      valid: true,
    };
  },
  methods: {
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    addedItem() {
      this.addOvertimeDialog = true;
    },
    editedItem(item) {
      this.editedIndex = this.overtime.indexOf(item);
      this.editItem = Object.assign({}, item);
      this.editOvertimeDialog = true;
      this.getOvertimeCategoryList();
    },
    deleteItem(item) {
      this.itemToDelete = Object.assign({}, item);
      this.deleteOvertimeDialog = true;
    },
    close() {
      this.addOvertimeDialog = false;
      this.editOvertimeDialog = false;
      this.deleteOvertimeDialog = false;
    },
    async getOvertimeCategoryList() {
      this.overtime_list = await this.$store.dispatch('getOvertimeCategory', { companyId: this.company_id })
    },
    async addOvertime(item) {
      this.loading = true;
      const result = await this.$store.dispatch('saveOvertimeCategory', {
        code: item.code,
        name_id: item.name_id,
        name_en: item.name_en,
        approval_type: item.approval_type,
        companyId: this.company_id,
      })
      this.loading = false;
      if (result) {
        this.addOvertimeDialog = false;
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.getOvertimeCategoryList();
      }
    },
    async editOvertime(item) {
      this.loading = true;
      const result = await this.$store.dispatch('editOvertimeCategory', {
        code: item.code,
        name_id: item.name_id,
        name_en: item.name_en,
        id: item.id,
        approval_type: item.approval_type,
        companyId: this.company_id,
      })
      this.loading = false;
      if (result) {
        this.editOvertimeDialog = false;
        this.showMessage('success', this.$i18n.t('alert_edit'))
        this.getOvertimeCategoryList();
      } else {
        this.editOvertimeDialog = true;
      }
    },
    async deleteOvertime(id) {
      const result = await this.$store.dispatch('deleteOvertimeCategory', {id})
      if (result) {
        this.deleteOvertimeDialog = false;
        this.showMessage('success', this.$i18n.t('alert_delete'))
        this.getOvertimeCategoryList();
      }
    },
  },
  created() {
    this.getOvertimeCategoryList();
  },
  watch: {
    dialog() {
      this.changeNUserStatus(this.editedItem.status);
      this.changeUserRole(this.editedItem.role);
    },
    addOvertimeDialog() {
      if (this.$refs.addForm) {
        this.$refs.addForm.reset();
      }
    },
  },
};
</script>
